import { z } from 'zod';
const MemberSchema = z.object({
    email: z.string().email(),
    role: z.enum(['ADMIN', 'MANAGER', 'MEMBER']),
});
export const organizationApiRoutes = {
    read: {
        method: 'GET',
        path: '/organization/:organizationId',
        output: {},
    },
    create: {
        method: 'POST',
        path: '/organization',
        input: z.object({
            name: z.string(),
            members: z.array(MemberSchema),
        }),
        output: {},
    },
    update: {
        method: 'POST',
        path: '/organization/:organizationId',
        input: z.object({
            name: z.string().optional(),
            storageLimit: z.number().optional(),
            themeId: z.string().optional(),
        }),
        output: {},
    },
    delete: {
        method: 'DELETE',
        path: '/organization/:organizationId',
        output: null,
    },
    brandColors: {
        method: 'GET',
        path: '/organization/:organizationId/brand-colors',
        output: {},
    },
    activity: {
        method: 'GET',
        path: '/organization/:organizationId/activity',
        output: {},
        q: z
            .object({
            createdAfter: z.string().optional(),
            between: z.tuple([z.string(), z.string()]).optional(),
            before: z.string().optional(),
            eventTypes: z
                .array(z.union([
                z.literal('org'),
                z.literal('projects'),
                z.literal('tasks'),
                z.literal('templates'),
            ]))
                .default(['org', 'projects', 'tasks', 'templates'])
                .optional(),
            userIds: z.array(z.string()).optional(),
        })
            .optional(),
    },
};
//# sourceMappingURL=organization-api-routes.js.map